
import { Chat, RemoveRedEye, Star } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import DialogCommentPriveCv from '../../../Components/Dialogs/DialogCommentPriveCv';
import CvAnonyme, { getMyNote } from '../../../Components/Docs/CvAnonyme';
import ChangeStatusCandidature from '../../../Components/shared/ChangeStatusCandidature';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { genreList, modeTravailEnum } from '../../../data/Interfaces';
import useAuth from '../../../hooks/useAuth';
import useGetRequest from '../../../hooks/useGetRequest';
import { useNumberFormatting } from '../../../hooks/useNumberFormatting';
import useRole from '../../../hooks/useRole';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { calculateTotalAnneeExperience, getDateDisponibilite, getExpertCompetences, getNomPrenomAnonymeFromPersoData, searchLabelInEnumByValue } from '../../../Utils/utils';
import { getPaymentSimulationResults } from '../../../Utils/utilsCraX';

export default function DossierById() {
    const { addEuro4Decimal } = useNumberFormatting();

    const role= useRole();
    const {auth} = useAuth();
    let {dossierId} = useParams();
    const {data: dossier, refresh} = useGetRequest({url: `/cvTheque/getDossierById/${dossierId}`});
    const [candidaturesArray, setCandidaturesArray] = useState([]);

    const [expert, setExpert] = useState();
    const [expertId, setExpertId] = useState();
    const [selectedCandidature, setSelectedCandidature] = useState();
    const [openCvAnonyme, setOpenCvAnonyme] = React.useState(false);
    const [openDialogCommentPriveCv, setOpenDialogCommentPriveCv] = useState(false);
    const [statusCandidatures, setStatusCandidatures] = useState([]);
    const { i18n } = useTranslation();
    const handleStatusChange = (index, newStatus) => {
        setStatusCandidatures(prevStatuses => {
            const updatedStatuses = [...prevStatuses];
            updatedStatuses[index] = newStatus;
            return updatedStatuses;
        });
    };

    useMemo(() => {
        if (dossier) {
            let tempArr = [];
            let annExp=0;
            console.log('dossier',dossier);
            dossier?.candidatures.reverse().forEach((candidat,index) => {
                handleStatusChange(index,candidat?.status);
                console.log('ooo',getExpertCompetences(candidat.expertId?.proData?.competencesTechnique));
                annExp= candidat.expertId?.proData?.otherInfo?.totalAnneeExperience ?? calculateTotalAnneeExperience(candidat.expertId?.proData?.experiences);
                tempArr.push({
                    'titre': candidat.expertId?.persoData?.genre,
                    'index':index,
                    'nomMasque': getNomPrenomAnonymeFromPersoData(candidat.expertId?.persoData),
                    'refExpert': candidat.expertId?.expertId,
                    'intitule': candidat.expertId?.persoData?.intitulePoste,
                    'modeTravail': candidat.expertId?.preference?.modeTravail?.type,
                    'dateDispo': getDateDisponibilite(candidat?.expertId?.preference?.dateDisponibilite),
                    'totalExp':annExp,
                    'tauxJour': role == 'admin' ? candidat?.expertId?.preference?.tjm : getPaymentSimulationResults({ tj: candidat?.expertId?.preference?.tjm, commissionHTH: 0.2 })?.tjClient,
                    'localisation': (candidat?.expertId?.preference?.residence?.ville??'') + '/' +(candidat?.expertId?.preference?.residence?.pays??'') ,
                    'argumentCommer': candidat.expertId?.persoData?.SyntheseProfile,
                    'createdAt': formatDateJJMMYYYY(candidat?.createdAt),
                    'recommandation': candidat.expertId?.recommendation?.cercle,
                    ...candidat
                });
            });
            setCandidaturesArray(tempArr);
        }
    }, [dossier]);

    // useEffect(() =>
    // }, [dossier]);

    const columns = [
        {
            field: 'eye',
            title: i18n.t('CV'),
            render: rowData =>
                <RemoveRedEye
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                        console.log({RemoveRedEye: rowData});
                        setSelectedCandidature(rowData);
                        setOpenCvAnonyme(true);
                        setExpertId(rowData?.expertId?._id);
                        setExpert(rowData?.expertId);
                    }}
                />
        },
        {
            field: 'refExpert',
            title: i18n.t('Réf. Expert'),
        },
        {
            field: 'titre',
            title: i18n.t('Titre'),
            render: (rowData)=>
                i18n.t(searchLabelInEnumByValue(genreList,rowData.titre))
        },
        {
            field: 'nomMasque',
            title: i18n.t('Nom'),
        },
        {
            field: 'intitule',
            title: i18n.t('Intitulé du CV'),
        },
        {
            field: 'competences',
            title: i18n.t('Compétences'),
            render: rowData =>
                <p style={{margin:0}}>
                    {getExpertCompetences(rowData?.expertId?.proData?.competencesTechnique)}-
                </p>
        },
        {
            field: 'totalExp',
            title: i18n.t('Total Exp.'),
            render: rowData =>
                addEuro4Decimal(rowData?.totalExp,i18n.t('ans'))
        },
        {
            field: 'statut',
            title: i18n.t('Statut Candidature'),
            render: rowData => {
                console.log({ rowData });
                return (
                    <ChangeStatusCandidature
                        width={'170px'}
                        defaultStatusCandidat={statusCandidatures[rowData?.index]}
                        setStatusCandidature={newStatus => handleStatusChange(rowData?.index, newStatus)}
                        expertId={rowData?.expertId?._id}
                        // aoId={rowData?.aoId}
                        // * Dossier Context
                        dossierId={dossier?._id}
                    />
                );
            }
        },
        {
            field: 'dateDispo',
            title: i18n.t('Date de disponibilité'),
            render: (rowData)=>
                i18n.t(rowData?.dateDispo)
        },
        {
            field: 'tauxJour',
            title: i18n.t('Taux journalier'),
            render:  rowData =>
                addEuro4Decimal(rowData?.tauxJour)
        },
        {
            field: 'modeTravail',
            title: i18n.t('Mode de travail'),
            render: (rowData)=>
                i18n.t(searchLabelInEnumByValue(modeTravailEnum,rowData.modeTravail))
        },
        {
            field: 'localisation',
            title: i18n.t('Ville/Pays'),
        },
        {
            field: 'evaluation',
            title: i18n.t('Evaluation'),
            render: (rowData) => {
                //* if I am the colllaborator so my is is on auth, otherwise I still has the id on rodata
                const collaboratorId = auth?.collaboratorId ?? rowData?.collaboratorId;
                return <>
                    {/* //faut ajouter un traitement selon la notation du client soit on affiche start ou half start */}
                    {getMyNote({ noteList: rowData?.note, collaboratorId: collaboratorId })?.evaluation ? <>
                        {getMyNote({ noteList: rowData?.note, collaboratorId: collaboratorId })?.evaluation}
                        <Star style={{ color: '#faaf00' }} />
                    </>
                        : null}
                </>;
            }
        },
        {
            field: 'commentaire',
            title: i18n.t('Commentaires'),
            render: rowData =>
                <IconButton
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                        setSelectedCandidature(rowData);
                        setOpenDialogCommentPriveCv(true);
                    }}
                >
                    <Chat />
                </IconButton>
        },
        {
            field: 'lastActivity',
            title: i18n.t('Dernière activité'),
            render: rowData =>
                <p>
                    {formatDateJJMMYYYY(rowData.updatedAt)}
                </p>
        },
    ];
    const [selectedRow, setSelectedRow] = React.useState(null);

    return (
        <>
            <div className='frame5Profile'>
                {i18n.t('CVThèque')} &gt;  <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Mes dossiers')}</span>
            </div>
            <div className='HomeFrame'>
                <h4 className='titlesociete'>
                    {dossier?.nom}
                </h4>
                <MaterialTableComponent
                    columns={columns}
                    data={candidaturesArray}
                    title="CandidaturesArray et BDC"
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                    }}
                    selectedRow={selectedRow}
                />
                {openCvAnonyme &&
                <CvAnonyme
                    openCvAnonyme={openCvAnonyme}
                    setOpenCvAnonyme={setOpenCvAnonyme}
                    expert={expert}
                    titreAO={dossier?.nom}
                    selectedCandidature={selectedCandidature}
                    refreshParentTable={refresh}
                    visualiseCvOnly={role == 'admin'}
                >
                    {/* //* I should send candidatureId rather than aoId :) */}
                    {role !== 'admin' &&
                    <ChangeStatusCandidature
                        width={'305px'}
                        expertId={expertId}
                        defaultStatusCandidat={statusCandidatures[selectedCandidature?.index]}
                        setStatusCandidature={newStatus => handleStatusChange(selectedCandidature?.index, newStatus)}
                        // aoId={dossier?._id}

                        // collaboratorIdDossierOwner={auth?.collaboratorId}
                        // candidatureId={selectedCandidature?._id}

                        dossierId={selectedCandidature?.dossierId}
                    />}
                </CvAnonyme>}
                {openDialogCommentPriveCv &&
                <DialogCommentPriveCv
                    //* ARRAY de tt les comment dans la candidature OR only the authentificated one ?? (not showed to other collaborators of the company)
                    commentaires= {selectedCandidature?.note}
                    openDialogCommentPriveCv={openDialogCommentPriveCv}
                    setOpenDialogCommentPriveCv={setOpenDialogCommentPriveCv}
                />}
            </div>
        </>
    );
}
